import Vue from "vue";
import VueRouter from "vue-router";
import { riverSeaRoutes } from "./river_sea/index.js";
import { navigationRoutes } from "./navigation/index.js";
import { activeRoutes } from "./active/index.js";
import { weatherRouteRows } from "@/router/weather";
import { agreementRoutes } from "./agreement/index.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "hello",
    redirect: "/weather/fishing_area_forecast",
    component: () => import("@/components/HelloWorld"),
  },
  // 经纬度转换
  {
    path: "/tools/lonlat_transition",
    name: "lonlat_transition",
    meta: {
      isKeepAlive: false,
      title: "经纬度转换",
    },
    component: () => import("@/components/lonlat_transition/index.vue"),
  },
  //海上急救指南
  {
    path: "/first_aid_at_sea_guide",
    name: "first_aid_at_sea_guide",
    meta: {
      isKeepAlive: false,
      title: "海上急救指南",
    },
    component: () => import("@/components/first_aid_at_sea_guide/index.vue"),
  },
  //海上急救指南详情
  {
    path: "/first_aid_at_sea_guide_detail",
    name: "first_aid_at_sea_guide_detail",
    meta: {
      isKeepAlive: false,
      title: "海上急救指南详情",
    },
    component: () => import("@/components/first_aid_at_sea_guide/detail.vue"),
  },
  // 常用单位转换
  {
    path: "/unit_conversion",
    name: "unit_conversion",
    meta: {
      isKeepAlive: false,
      title: "常用单位转换",
    },
    component: () => import("@/components/unit_conversion/index.vue"),
  },
  //鱼类百科
  {
    path: "/encyclopedia_fish",
    name: "encyclopedia_fish",
    meta: {
      isKeepAlive: false,
      title: "鱼类百科",
    },
    component: () => import("@/components/encyclopedia_fish/index.vue"),
  },
  //鱼类百科详情
  {
    path: "/encyclopedia_fish_detail",
    name: "encyclopedia_fish_detail",
    meta: {
      isKeepAlive: false,
      title: "鱼类百科详情",
    },
    component: () => import("@/components/encyclopedia_fish/detail.vue"),
  },
  //海图符号指南
  {
    path: "/guide_chart_symbols",
    name: "guide_chart_symbols",
    meta: {
      isKeepAlive: false,
      title: "海图符号指南",
    },
    component: () => import("@/components/guide_chart_symbols/index.vue"),
  },
  //操作手册
  {
    path: "/operation_manual",
    name: "operation_manual",
    meta: {
      isKeepAlive: false,
      title: "操作手册",
    },
    component: () => import("@/components/operation_manual/index.vue"),
  },
  //操作手册详情
  {
    path: "/operation_manual_detail",
    name: "operation_manual_detail",
    meta: {
      isKeepAlive: false,
      title: "操作手册详情",
    },
    component: () => import("@/components/operation_manual/detail.vue"),
  },
  // 政策法规
  {
    path: "/policies_regulations",
    name: "policies_regulations",
    meta: {
      isKeepAlive: false,
      title: "政策法规",
    },
    component: () => import("@/components/policies_regulations/index.vue"),
  },
  // VTS报告制度
  {
    path: "/vts_reporting_system",
    name: "vts_reporting_system",
    meta: {
      isKeepAlive: false,
      title: "VTS报告制度",
    },
    component: () => import("@/components/vts_reporting_system/index.vue"),
  },
  // pdf预览
  {
    path: "/pdf_preview",
    name: "pdf_preview",
    meta: {
      isKeepAlive: false,
      title: "pdf预览",
    },
    component: () => import("@/components/pdf_preview/index.vue"),
  },
  // pdf预览多页
  {
    path: "/pdf_preview2",
    name: "pdf_preview2",
    meta: {
      isKeepAlive: false,
      title: "pdf预览",
    },
    component: () => import("@/components/pdf_preview2/index.vue"),
  },
  // doc
  {
    path: "/doc_preview",
    name: "doc_preview",
    meta: {
      isKeepAlive: false,
      title: "doc",
    },
    component: () => import("@/components/doc_preview/index.vue"),
  },
  // 海图在线选图
  {
    path: "/map_select",
    name: "map_select",
    meta: {
      isKeepAlive: false,
      title: "海图在线选图",
    },
    component: () => import("@/components/map_select/index.vue"),
  },
  // 船舶管理
  {
    path: "/ship_management",
    name: "ship_management",
    meta: {
      isKeepAlive: false,
      title: "船舶管理",
    },
    component: () => import("@/components/ship_management/index.vue"),
  },
  // 海事综合查询
  {
    path: "/maritime_search",
    name: "maritime_search",
    meta: {
      isKeepAlive: false,
      title: "海事综合查询",
    },
    component: () => import("@/components/maritime_search/index.vue"),
  },
  // 南通预告发布
  {
    path: "/forcast_publish",
    name: "forcast_publish",
    meta: {
      isKeepAlive: false,
      title: "南通预告发布",
    },
    component: () => import("@/components/forcast_publish/index.vue"),
  },
  // 机构预报
  {
    path: "/institution_forcast",
    name: "institution_forcast",
    meta: {
      isKeepAlive: false,
      title: "机构预报",
    },
    component: () => import("@/components/institution_forcast/index.vue"),
  },
  ...activeRoutes,
  ...riverSeaRoutes,
  ...weatherRouteRows,
  ...navigationRoutes,
  ...agreementRoutes,
];

const router = new VueRouter({
  mode: "hash",
  base: process.env.VUE_APP_PUBLIC_BUILD_PATH,
  routes,
});

export default router;
